
export const breakpoints = {
    miniMobile: 450,
    mobileMax: 767,
    tabletVerticalMax: 991,
    TabletHorizontalMax: 1199,
}
export const themeLight = {
    breakpoints,
    colors: {
        textPrimary: "#252525",
        body: {
            background: "#FBFBFE",
            text: "#6E7E91"
        },
        buttonLink: {
            buttonBackground: "#0366D6",
            buttonHover: "#2188FF",
        },
        tile: {
            tileBackground: "#FFFFFF",
            tileShadow: "#ddd",
        },
        themeSwitch: {
            boxBackground: "#E5E5E5",
            icon: "#FFFFFF",
        },
        portfolioIcon: "#0366D6",
        boxShadow: "0px -2px 50px rgba(9, 10, 51, 0.02), 0px 16px 58px rgba(9, 10, 51, 0.03)",
        PortfolioHeader: "#0366D6",
        Link: "#0366D6",
        buttonColor: "#FFFFFF",
        navbarColor: "#FFFFFF",
    },
};

export const themeDark = {
    breakpoints,
    colors: {
        textPrimary: "#FFFFFF",
        body: {
            background: "#252525",
            text: "#FFFFFF"
        },
        buttonLink: {
            buttonBackground: "#2188FF",
            buttonHover: "#0366D6",
        },
        tile: {
            tileBackground: "#363636b8",
            tileShadow: "#090A33",
        },
        themeSwitch: {
            boxBackground: "#6D6C6C",
            icon: "#252525",
        },
        portfolioIcon: "#2188FF",
        boxShadow: "0px -2px 50px rgba(9, 10, 51, 0.02), 0px 16px 58px rgba(9, 10, 51, 0.03)",
        PortfolioHeader: "#FFFFFF",
        Link: "#2188FF",
        buttonColor: "#000000",
        navbarColor: "#363636ff",
    },
};



